export const menuToggle = function (el) {
    const menuEnabler = el.querySelector("[data-enable-menu]");
    const menuDisabler = el.querySelector("[data-disable-menu]");
    console.log(menuEnabler, menuDisabler);
    if (menuEnabler) {
        menuEnabler.addEventListener("click", function () {
            document.body.classList.add("menu-enabled");
        });
    }
    if (menuDisabler) {
        menuDisabler.addEventListener("click", function () {
            document.body.classList.remove("menu-enabled");
        });
    }
};
